var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnShieldBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.601 6.48L12.574.07a.597.597 0 00-.569.004L.311 6.482A.599.599 0 000 7.008v8.371a17.333 17.333 0 0010.39 15.864l1.622.707a.598.598 0 00.477 0l1.829-.79a17.3 17.3 0 0010.6-15.947V7.008a.6.6 0 00-.317-.529zm-.88 8.733a16.105 16.105 0 01-9.872 14.846l-.004.002-1.593.688-1.384-.604a16.134 16.134 0 01-9.67-14.766V7.362L12.296 1.28 23.72 7.367v7.846z",
    fill: "#15595D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88 14.99a.599.599 0 00-.912.778l3.163 3.704a.599.599 0 00.833.076l7.366-5.993a.599.599 0 10-.755-.929l-6.913 5.624-2.783-3.26z",
    fill: "#15595D"
  })));
}
export default SvgIcnShieldBold;